<template>
  <v-dialog
    @input="$emit('close')"
    :value="show"
    max-width="1200"
  >
    <v-card v-if="player" style="background-color: #fafafa">
      <v-card-title class="headline theme--dark indigo darken-4" primary-title>
        <Flag :code="selectedPlayer.teamCode" :height="50"/>
        <span style="color: #fff" class="mr-2">{{ player.noShirt }}</span>
        <span style="color: #fff">{{ player.volleyballPlayer.firstNamePlayer }} {{ player.volleyballPlayer.lastNamePlayer }}</span>
      </v-card-title>

      <v-container fluid grid-list-md>
        <v-layout>
          <v-flex xs5>
            <v-img :src="`${player.volleyballPlayer.photoUrl}`" height="700px" :contain="true" />
          </v-flex>

          <v-flex>
            <v-card-text v-if="byTournament !== null">
              <v-layout>
                <v-flex>
                  <p class="text-xs-center subheading">AGE</p>
                  <p class="text-xs-center display-2">{{ age }}</p>
                </v-flex>
                <v-flex>
                  <p class="text-xs-center subheading">HEIGHT (CM)</p>
                  <p class="text-xs-center display-2">{{ player.volleyballPlayer.height / 10000 }}</p>
                </v-flex>
                <v-flex>
                  <p class="text-xs-center subheading">MATCH POINTS</p>
                  <p class="text-xs-center display-2">{{ orZero(selectedPlayer.totalPoints) }}</p>
                </v-flex>
                <v-flex>
                  <p class="text-xs-center subheading">TOURNAMENT POINTS</p>
                  <p class="text-xs-center display-2">{{ orZero(byTournament.pointTotal) }}</p>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-text>
              <h2 class="text-xs-center title">MATCH PERFORMANCE</h2>
            </v-card-text>

            <v-card-text v-if="byMatch !== null">
              <table class="v-datatable v-table theme--light">
                <thead>
                  <tr>
                    <th class="column text-xs-center">SKILLS</th>
                    <th class="column text-xs-center">POINTS</th>
                    <th class="column text-xs-center">% SUCC.</th>
                    <th class="column text-xs-center">FAULTS</th>
                    <th class="column text-xs-center">CONTINUES</th>
                    <th class="column text-xs-center">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>ATTACK</td>
                    <td class="text-xs-center">{{ orZero(byMatch.spikePoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byMatch.spikePoint) / byMatch.spikeTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byMatch.spikeFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.spikeContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.spikeTotal) }}</td>
                  </tr>
                  <tr>
                    <td>BLOCK</td>
                    <td class="text-xs-center">{{ orZero(byMatch.blockPoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byMatch.blockPoint) / byMatch.blockTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byMatch.blockFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.blockContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.blockTotal) }}</td>
                  </tr>
                  <tr>
                    <td>SERVE</td>
                    <td class="text-xs-center">{{ orZero(byMatch.servePoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byMatch.servePoint) / byMatch.serveTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byMatch.serveFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.serveContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byMatch.serveTotal) }}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td class="text-xs-center">{{ orZero(byMatch.pointTotal) }}</td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>

            <v-card-text>
              <h2 class="text-xs-center title">TOURNAMENT PERFORMANCE</h2>
            </v-card-text>

            <v-card-text v-if="byTournament !== null">
              <table class="v-datatable v-table theme--light">
                <thead>
                  <tr>
                    <th class="column text-xs-center">SKILLS</th>
                    <th class="column text-xs-center">POINTS</th>
                    <th class="column text-xs-center">% SUCC.</th>
                    <th class="column text-xs-center">FAULTS</th>
                    <th class="column text-xs-center">CONTINUES</th>
                    <th class="column text-xs-center">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>ATTACK</td>
                    <td class="text-xs-center">{{ orZero(byTournament.spikePoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byTournament.spikePoint) / byTournament.spikeTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byTournament.spikeFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.spikeContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.spikeTotal) }}</td>
                  </tr>
                  <tr>
                    <td>BLOCK</td>
                    <td class="text-xs-center">{{ orZero(byTournament.blockPoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byTournament.blockPoint) / byTournament.blockTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byTournament.blockFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.blockContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.blockTotal) }}</td>
                  </tr>
                  <tr>
                    <td>SERVE</td>
                    <td class="text-xs-center">{{ orZero(byTournament.servePoint) }}</td>
                    <td class="text-xs-center">{{ orZero(Math.floor(orZero(byTournament.servePoint) / byTournament.serveTotal * 100)) }}%</td>
                    <td class="text-xs-center">{{ orZero(byTournament.serveFault) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.serveContinue) }}</td>
                    <td class="text-xs-center">{{ orZero(byTournament.serveTotal) }}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td class="text-xs-center">{{ orZero(byTournament.pointTotal) }}</td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                    <td class="text-xs-center"></td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import { Request } from '@fivb/sdk'
  import Flag from '@/components/Flag'
import { clearTimeout, setTimeout } from 'timers';

  export default {
    components: { Flag },
    props: ['show', 'selectedPlayer'],

    data: () => ({
      byTournament: null,
      byMatch: null,
      timeoutId: null,
    }),

    watch: {
      selectedPlayer () {
        if (this.show === true) {
          this.fetchPlayerStatistics()
        }
      },

      show: function (val) {
        if (val === false) {
          clearTimeout(this.timeoutId)
        }
      }
    },

    computed: {
      age () {
        if (this.player) {
          return this.calcAge(this.player.volleyballPlayer.birthdate)
        }
      },

      player () {
        if (this.show) {
          return this.$store.state.matchLiveInformation.players[this.selectedPlayer.noPlayer]
        }
      }
    },

    methods: {
      orZero (val) {
        if (Number.isInteger(val)) {
          return val
        }

        return 0
      },

      calcAge (dateString) {
        const birthday = +new Date(dateString)
        return ~~((Date.now() - birthday) / (31557600000))
      },

      async fetchPlayerStatistics () {
        const byTournamentQuery = new Request('GetVolleyStatisticList')
          .addAttribute('Fields', 'No NoTournament BlockContinue BlockFault BlockPoint BlockTotal  ServeContinue ServeFault ServePoint ServeTotal SpikeContinue SpikeFault SpikePoint SpikeTotal PointTotal')
          .addAttribute('SumBy', 'Tournament')
          .addFilter('NoTournaments', this.$store.state.matchLiveInformation.tournament.no)
          .addFilter('NoPlayer', this.selectedPlayer.noPlayer)
          .addFilter('MatchesToUse', 'MatchesStarted')
          .toString()

        const byMatchQuery = new Request('GetVolleyStatisticList')
          .addAttribute('Fields', 'No NoTournament NoMatch BlockContinue BlockFault BlockPoint BlockTotal  ServeContinue ServeFault ServePoint ServeTotal SpikeContinue SpikeFault SpikePoint SpikeTotal PointTotal')
          .addAttribute('SumBy', 'Match')
          .addFilter('NoTournaments', this.$store.state.matchLiveInformation.tournament.no)
          .addFilter('NoMatches', this.$store.state.matchLiveInformation.match.no)
          .addFilter('NoPlayer', this.selectedPlayer.noPlayer)
          .addFilter('MatchesToUse', 'MatchesStarted')
          .toString()

        const [{ data: byTournament }, { data: byMatch }] = await Promise.all([
          this.fetchData(byTournamentQuery),
          this.fetchData(byMatchQuery),
        ])

        this.byTournament = byTournament[0]
        this.byMatch = byMatch[0]

        this.timeoutId = setTimeout(() => {
          this.fetchPlayerStatistics()
        }, 15000)
      },

      async fetchData (query) {
        return (await fetch(process.env.VUE_APP_FIVB_API_URL, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-store',
          headers: new Headers({
            'Content-Type': 'application/xml',
            'Accept': 'application/json',
            'X-FIVB-App-ID': '3b665ad61056495ab5514b81eb0562d8'
          }),
          body: query,
        }).then(response => response.json()))
      },
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayerModal/PlayerModal.vue